import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { messagesAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import './Messages.css';

export default function ConversationsPage() {
  const { user } = useAuth();
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await messagesAPI.getConversations();
        setConversations(data.conversations);
      } catch { /* ignore */ }
      setLoading(false);
    };
    load();
  }, []);

  if (loading) return <div className="loading-center"><div className="spinner" /></div>;

  const getOtherUser = (conv) => conv.participants.find(p => p._id !== user._id);

  return (
    <div className="messages-page fade-in">
      <div className="page-header">
        <h1>Messages</h1>
      </div>

      {conversations.length === 0 ? (
        <div className="empty-state">
          <span className="empty-icon">✉️</span>
          <h3>No conversations yet</h3>
          <p>Visit a user's profile to send them a message.</p>
        </div>
      ) : (
        <div className="conversations-list card">
          {conversations.map(conv => {
            const other = getOtherUser(conv);
            if (!other) return null;
            const lastMsg = conv.lastMessage;
            return (
              <Link key={conv._id} to={`/messages/${conv._id}`} className="conversation-item">
                <div className="conversation-avatar">
                  {other.profilePicture ? (
                    <img src={other.profilePicture} alt={other.username} />
                  ) : (
                    <span>{other.username[0].toUpperCase()}</span>
                  )}
                </div>
                <div className="conversation-info">
                  <div className="conversation-top">
                    <span className="conversation-name">{other.username}</span>
                    {lastMsg && (
                      <span className="conversation-time">
                        {new Date(conv.lastMessageAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                      </span>
                    )}
                  </div>
                  <p className="conversation-preview">
                    {lastMsg ? lastMsg.text : 'No messages yet'}
                  </p>
                </div>
                {conv.unreadCount > 0 && (
                  <span className="unread-badge">{conv.unreadCount}</span>
                )}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
